"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlRendererSharedState = void 0;
const entity_buffer_store_1 = require("../buffers/entity-buffer-store");
/**
 * @public
 * {@inheritDoc IGlRendererSharedState}
 */
class GlRendererSharedState {
    constructor(context, extensions, isGl2) {
        this.context = context;
        this.extensions = extensions;
        this.isGl2 = isGl2;
        this.textureIndex = 0;
        this.frameCounter = 0;
        this.scissorRange = null;
        this.entityBuffers = new entity_buffer_store_1.EntityBufferStore();
        this.activeProgram = null;
        this.activeVao = null;
        this.maxTextureCount = context.getParameter(context.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    }
    static createOne(context, extensions, isGl2) {
        if (context == null || extensions == null) {
            return null;
        }
        // shared state is not type checked
        return new GlRendererSharedState(context, extensions, isGl2);
    }
    setContext(context) {
        this.context = context;
    }
    onNewFrame() {
        ++this.frameCounter;
    }
    onContextLost() {
        this.scissorRange = null;
        this.textureIndex = 0;
    }
    clearScissor() {
        if (this.scissorRange != null) {
            this.context.disable(this.context.SCISSOR_TEST);
            this.updateScissorRange(null);
            this.scissorRange = null;
        }
    }
    updateScissorRange(range) {
        if (range == null) {
            return this.clearScissor();
        }
        if (this.scissorRange == null) {
            this.context.enable(this.context.SCISSOR_TEST);
            this.scissorRange = range;
        }
        // scissor and viewport start in the bottom left
        this.context.scissor(range.getXMin() | 0, range.getYMin() | 0, 1 + range.getXRange() | 0, 1 + range.getYRange() | 0);
    }
    claimTextureUnit() {
        return this.textureIndex++;
    }
    isProgramActive(program) {
        return this.activeProgram === program;
    }
    useProgram(program) {
        if (this.activeProgram === program) {
            return;
        }
        this.context.useProgram(program);
        this.activeProgram = program;
    }
    bindVao(vao) {
        if (this.activeVao === vao) {
            return;
        }
        if (this.isGl2) {
            this.context.bindVertexArray(vao);
        }
        else {
            this.extensions.OES_vertex_array_object.bindVertexArrayOES(vao);
        }
        this.activeVao = vao;
    }
}
exports.GlRendererSharedState = GlRendererSharedState;
//# sourceMappingURL=gl-renderer-shared-state.js.map